import { render, staticRenderFns } from "./PersonName.vue?vue&type=template&id=cb5cc1c4"
import script from "./PersonName.vue?vue&type=script&lang=js"
export * from "./PersonName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports